import { TableHeaderCell } from 'common/components';
import type { TableFilterOption } from '../CallsTable';

type DispositionCellProps = {
    filterDisposition: string;
    dispositionOptions: TableFilterOption[];
    onFilterDisposition: (value: string) => void;
};

export const DispositionCell = ({
    filterDisposition,
    dispositionOptions,
    onFilterDisposition,
}: DispositionCellProps) => {
    const options = [{ value: '', label: 'All dispositions' }, ...dispositionOptions];

    return (
        <TableHeaderCell
            label='Disposition'
            filterOptions={{
                options,
                selectedValue: filterDisposition,
                onChange: onFilterDisposition,
            }}
        />
    );
};
